export * from './lib/product-color.dto';
export * from './lib/product-color.service';
